module.exports = __webpack_public_path__ + "img/splash.ea14e685.png";